
import { IWeatherData } from "./IWeatherData";


export class WeatherData implements IWeatherData
{
    cloudiness: number = 0;
    componentId: number = 0;
    conditionCode: number = 0;
    conditionDescription: string = "";
    conditionType: string = "";
    creationDate: Date = new Date();
    groundLevelPressure: number = 0;
    humidity: number = 0;
    latitude: number = 0;
    longitude: number = 0;
    maxTemperature: number = 0;
    minTemperature: number = 0;
    pressure: number = 0;
    rain: number = 0;
    seaLevelPressure: number = 0;
    snow: number = 0;
    temperature: number = 0;
    windDirection: number = 0;
    windSpeed: number = 0;
}
